import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { changePassword } from '../../../services/userService';
import { logo } from '../../imagepath';

const ForgotPasswordChange = () => {
  const { passwordtoken } = useParams();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setError('Şifreler uyuşmuyor.');
      setMessage(null);
      return;
    }
    try {
      const response = await changePassword({ passwordtoken, password });
      if (response.status === 'OK') {
        setMessage(response.message);
        setError(null);
      } else {
        setError(response.message);
        setMessage(null);
      }
    } catch (error) {
      setError('Şifre değiştirme işlemi sırasında bir hata oluştu.');
      setMessage(null);
    }
  };

  return (
    <div className="d-flex flex-column min-vh-100">
      <div className="flex-grow-1">
        <div className="container-fluid">
          <div className="row min-vh-100 justify-content-center align-items-center">
            <div className="col-12 col-sm-8 col-md-6 col-lg-4 mt-5">
              {/* Logo kutusu */}
              <div className="bg-light rounded-4 shadow-sm p-3 mb-4 d-flex justify-content-center">
                <Link to="/home">
                  <img src={logo} className="img-fluid" alt="Logo" style={{ maxHeight: 50 }} />
                </Link>
              </div>
              {/* Form kutusu */}
              <div className="bg-light rounded-4 shadow-sm p-4">
                <h4 className="fw-semibold mb-2 text-center text-darkfume ">Şifre Değiştir</h4>
                <hr className="mb-4 mt-0" />
                <form onSubmit={handleSubmit}>
                  <div className="input-block">
                    <label className="form-control-label text-darkfume text-sm">Yeni Şifre</label>
                    <input
                      type="password"
                      className="form-control"
                      placeholder="Yeni Şifre"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                  </div>
                  <div className="input-block">
                    <label className="form-control-label text-darkfume text-sm">Şifreyi Onayla</label>
                    <input
                      type="password"
                      className="form-control"
                      placeholder="Şifreyi Onayla"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      required
                    />
                  </div>
                  {error && <p style={{ color: 'red' }}>{error}</p>}
                  {message && <p style={{ color: 'green' }}>{message}</p>}
                  <div className="d-grid">
                    <button className="btn bg-info text-sm " type="submit">
                      Şifreyi Değiştir
                    </button>
                  </div>
                </form>
                <div className="text-sm text-center mt-4">
                  <p className="mb-0">
                    <Link className="text-blue me-4" to="/login">Giriş Yap </Link>
                    <Link className="text-blue" to="/register">Kayıt Ol </Link>
                  </p>
               
                </div>
              </div>
            </div>
            <footer className="w-100 text-center mt-auto mb-2">
              <small className="text-secondary">
                © 2025 Ideal Online &middot;
                <Link to="/support" className="text-secondary text-decoration-none mx-1">Destek</Link> &middot;
                <Link to="/kvkk" className="text-secondary text-decoration-none mx-1">KVKK</Link> &middot;
                <Link to="/help" className="text-secondary text-decoration-none mx-1">Yardım</Link>
              </small>
            </footer>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordChange;
